import { useTranslation } from "react-i18next";
import PageWrapper from "../../../../../components/common/layout/PageWrapper";
import { BorderGreyBox, BoxSpg, CardSpg } from "@duosoftbg/nacid-components";
import { CardContent } from "@mui/material";
import ARUniEntryRequestFilterForm from "../../../../../components/registers/request/arUni/form/ARUniEntryRequestFilterForm";
import ARUniEntryRequestAdminList from "../../../../../components/registers/admin/request/arUni/list/ARUniEntryRequestAdminList";

const ARUniEntryRequestAdminPage = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper centerTitle title={t("t.acArUniEntryRequest")}>
      <CardSpg my={4} style={{ overflow: "visible" }}>
        <CardContent style={{ position: "relative" }}>
          <BoxSpg>
            <BorderGreyBox>
              <ARUniEntryRequestFilterForm withUserFilter={true} />
            </BorderGreyBox>
            <ARUniEntryRequestAdminList />
          </BoxSpg>
        </CardContent>
      </CardSpg>
    </PageWrapper>
  );
};
export default ARUniEntryRequestAdminPage;
